import { ASSET_CONFIG } from './assetConfig';

interface NamedItem {
  iid: number;
  core?: number[];
  props?: { lines?: { stat: number }[]; hyName?: string };
}
const prefixes: { [key: number]: string } = {
  1: 'Strong', 2: 'Fast', 3: 'Hearty', 4: 'Tenacious', 5: 'Ruining', 6: 'Deft', 7: 'Accurate',
  8: 'Life', 9: 'Vivacious', 10: 'Sharp', 11: 'Savage', 12: 'Speedy', 13: 'Energy', 14: 'Pneuma',
  15: 'Barbaric', 16: 'Flexible', 17: 'Guarding', 18: 'Fatal', 19: 'Sharp',
};
const colors = ['rgba(255, 255, 255, 1)', 'rgba(30, 255, 0, 1)', 'rgba(0, 112, 221, 1)', 'rgba(163, 53, 238, 1)', 'rgba(255, 128, 0, 1)'];
export function getItemNameColor(item: NamedItem) {
  if (item.core?.[4] === 0) {
    const value = Number(ASSET_CONFIG.ITEMS?.[item.iid]?.[1] ?? 0);
    return value >= 40 ? '#ff8000' : value >= 30 ? '#0070dd' : '#b0b0b0';
  }
  return colors[Math.min(item.props?.lines?.length ?? 0, colors.length - 1)];
}
export function getItemDisplayName(item: NamedItem, translate: (key: string) => string) {
  return [...(item.props?.lines ?? []).map(line => prefixes[line.stat]).filter(Boolean).map(key => translate(key)), item.props?.hyName || translate(`item__${item.iid}--name`)].join(' ');
}
